export default __webpack_public_path__ + "static/media/money-bag.d976ab22.svg";